//<-- used in sendNotes for create multiple articles .bass-tab from createBassTab() and .guitar-tab from createGuitarTab().
const data = [
    {
        className: 'A',
        nextClassName: 'B',
        countState: 1,
        id: 2
    },
    {
        className: 'B',
        nextClassName: 'C',
        countState: 2,
        id: 3
    },
    {
        className: 'C',
        nextClassName: 'D',
        countState: 3,
        id: 4
    },
    {
        className: 'D',
        nextClassName: 'E',
        countState: 4,
        id: 5
    },
    {
        className: 'E',
        nextClassName: 'F',
        countState: 5,
        id: 6
    },
    {
        className: 'F',
        nextClassName: 'G',
        countState: 6,
        id: 7
    },
];

export default data;